import { useEffect, useState } from 'react';
import { getSlokasByLanguage } from '../api/dataService';
import { DEFAULT_LANGUAGE } from '../utils/defaultLanguage';

export function useTrackLyrics(track, language = DEFAULT_LANGUAGE) {
  const [lyrics, setLyrics] = useState(null);

  useEffect(() => {
    if (!track) {
      setLyrics(null);
      return undefined;
    }

    if (track.slokaText || track.meaningText) {
      setLyrics({
        slokaText: track.slokaText || '',
        meaningText: track.meaningText || '',
        speaker: track.speaker || ''
      });
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const slokas = await getSlokasByLanguage(language);
        const match = slokas.find(
          (s) =>
            s.chapterNumber === track.chapterNumber &&
            s.slokaNumber === track.slokaNumber
        );

        if (!cancelled && match) {
          setLyrics({
            slokaText: match.sloka || '',
            meaningText: match.meaning || '',
            speaker: match.speaker || ''
          });
        }
      } catch {
        if (!cancelled) setLyrics(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [track, language]);

  if (!track) return null;

  return {
    ...track,
    slokaText: lyrics?.slokaText ?? track.slokaText ?? '',
    meaningText: lyrics?.meaningText ?? track.meaningText ?? '',
    speaker: lyrics?.speaker ?? track.speaker ?? ''
  };
}
